import { useEffect } from 'react';
import { userManager } from './oidcConfig';

const OidcSignOutCallback = () => {
    useEffect(() => {
        userManager.signoutRedirectCallback().then(() => {
            window.location.replace('/');
        });
    }, []);

    return <p>Loading...</p>;
};

export default OidcSignOutCallback;
